var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.399963,
    y: 0.861328,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#ECEEF4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3981_24939",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 29,
    height: 29
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.39996,
    y: 8.86133,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3981_24939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.125 29.861H14.0875C13.6208 29.861 13.2708 29.6568 13.0375 29.2485C12.8041 28.8402 12.8236 28.4416 13.0958 28.0527L16.5666 22.861H16.4791C16.0125 22.861 15.6673 22.652 15.4437 22.2339C15.2201 21.8159 15.2444 21.4124 15.5166 21.0235L21.4375 12.5652C21.5541 12.4096 21.7 12.2881 21.875 12.2006C22.05 12.1131 22.225 12.0693 22.4 12.0693C22.575 12.0693 22.75 12.1131 22.925 12.2006C23.1 12.2881 23.2458 12.4096 23.3625 12.5652L29.2833 21.0235C29.5555 21.4124 29.5798 21.8159 29.3562 22.2339C29.1326 22.652 28.7875 22.861 28.3208 22.861H28.2333L31.7041 28.0527C31.9763 28.4416 31.9958 28.8402 31.7625 29.2485C31.5291 29.6568 31.1791 29.861 30.7125 29.861H24.675V33.361C24.675 33.6916 24.5631 33.9686 24.3395 34.1923C24.1159 34.4159 23.8388 34.5277 23.5083 34.5277H21.2916C20.9611 34.5277 20.684 34.4159 20.4604 34.1923C20.2368 33.9686 20.125 33.6916 20.125 33.361V29.861Z",
    fill: "#41558D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremier);
export default __webpack_public_path__ + "static/media/premier.839367810d14d63b1fbe8e398a3e5e7b.svg";
export { ForwardRef as ReactComponent };